// extracted by mini-css-extract-plugin
export default {"orderInformation":"IEThI","left":"lR+Ao","right":"H8TN3","greeting":"EMcj0"};